import { GLOBAL_FOOTER_HEIGHT } from "@/constants/styles/footer";
import { Container, Text, useMantineTheme } from "@mantine/core";

export function Footer() {
	const theme = useMantineTheme();

	return (
		<footer
			style={{
				position: "fixed",
				bottom: 0,
				width: "100%",
				height: GLOBAL_FOOTER_HEIGHT,
				borderTop: `1px solid ${theme.colors.gray[2]}`,
				backgroundColor: theme.colors.gray[0],
			}}
		>
			<Container
				size="xl"
				style={{
					height: GLOBAL_FOOTER_HEIGHT,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Text>© Algomatic Works Inc. All Rights Reserved.</Text>
			</Container>
		</footer>
	);
}
